import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-text-editor',
  templateUrl: './text-editor.component.html',
  styleUrls: ['./text-editor.component.scss']
})
export class TextEditorComponent implements OnInit {
  @Input() mainForm!: UntypedFormGroup;

  @Input() controlName!: string;

  control!: AbstractControl | null;

  constructor() { }

  ngOnInit(): void {
    this.init();
  }

  onEditorCreated(editor: any): void {
    // Strip all formatting (styles, fonts, colors, etc.) from pasted content,
    // keeping only plain text — but ONLY for real user pastes.
    //
    // Quill matchers run on every clipboard.convert(), and ngx-quill sets the
    // form-control value into the editor via clipboard.convert({ html }) too.
    // Without this guard the matcher would also strip the formatting of content
    // we set programmatically (e.g. when switching templates from the dropdown),
    // showing plain text in the editor while the PDF still rendered the markup.
    let isPasting = false;
    editor.root.addEventListener('paste', () => {
      isPasting = true;
      // Reset after Quill has finished handling this paste synchronously.
      setTimeout(() => { isPasting = false; }, 0);
    }, true);

    editor.clipboard.addMatcher(Node.ELEMENT_NODE, (_node: any, delta: any) => {
      if (isPasting) {
        delta.ops = delta.ops.map((op: any) => ({ insert: op.insert }));
      }
      return delta;
    });
  }

  // ngx-quill 26 reads the form value via Quill 2's getSemanticHTML(), which
  // HTML-escapes the text content itself: every literal " becomes &quot; and
  // ' becomes &#39; (and each space becomes &nbsp;). Those encoded quotes trip
  // the WAF firewall and cause a 403 on submit. Decode them back to the literal
  // characters. We intentionally leave &amp;/&lt;/&gt; encoded so the markup
  // stays valid and safe.
  valueGetter = (quillEditor: any): string =>
    quillEditor
      .getSemanticHTML()
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&nbsp;/g, ' ');

  private init(): void {
    this.control = this.mainForm.get(this.controlName);
  }
}
